declare const __API_BASE__: string;
declare const __SDK_VERSION__: string;
export const API_BASE: string = __API_BASE__;
export const SDK_VERSION: string = __SDK_VERSION__;
